import Form from 'components/Form';
import { IFormValues, IFormRegister } from 'routes/Main/type';
import { Fragment } from 'react';
import { Stack } from '@mui/material';

import RowContainer from '../../components/RowContainer';
import RowContent from './components/RowContentSub';
import SectionTitle from '../../components/SectionTitle';

interface Props extends IFormValues {
  disabled?: boolean;
}

const Attention = (props: Props) => {
  const { disabled, getValues, setValue } = props;

  return (
    <Fragment>
      <SectionTitle title="인지 - 주의집중, 추상적인 사고 " />

      <RowContainer xs={12}>
        <RowContent title="주의집중" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('attention.focus.value')}
              onChange={v => setValue('attention.focus.value', v)}
            />
          </Stack>
        </RowContent>
        <RowContent title="추상적인 사고" titleRatio={1.2} childrenRatio={10.8}>
          <Stack direction="row" spacing={1} sx={{ marginLeft: '-10px' }}>
            <Form.MuiRadioGroup
              i18nKey="ORIENTATION"
              values={[1, 2]}
              disabled={disabled}
              defaultValue={getValues('attention.mse_abstract.value')}
              onChange={v => setValue('attention.mse_abstract.value', v)}
            />
          </Stack>
        </RowContent>
      </RowContainer>
    </Fragment>
  );
};

export default Attention;
